const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? ""
    : process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:3060";

export { API_BASE_URL };
export const API_URL = `${API_BASE_URL}/apivocabularium`;
